<div class="checkballs">
    <div class="checkballs-track" [ngClass]="getProgressStep()">
        <div class="checkballs-segment first" [ngClass]="getStatus1()">
            <div class="bar"></div>
            <p>Declaración</p>
        </div>
        <div class="checkballs-segment" [ngClass]="getStatus2()">
            <div class="bar"></div>
            <p>Datos del asegurado</p>
        </div>
        <div class="checkballs-segment last" [ngClass]="getStatus3()">
            <div class="bar"></div>
            <p>Datos contacto</p>
        </div>
    </div>
</div>
